import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'content', 'indicator'];
  static values = { activeTab: String };

  connect() {
    this.showActiveTab();
  }

  selectTab(event) {
    // Prevent the default link behavior
    event.preventDefault();

    const clickedTab = event.currentTarget;
    const tabName = clickedTab.dataset.tab;

    // Update active tab value
    this.activeTabValue = tabName;

    // Update tab styles
    this.updateTabStyles(clickedTab);

    // Show corresponding content
    this.showTabContent(tabName);

    // Update the URL without page reload using History API
    const url = new URL(clickedTab.href);
    window.history.pushState({}, '', url);

    // Optionally, make an AJAX request to update the content
    // This will send the tab parameter to the controller
    this.fetchTabContent(tabName);
  }

  fetchTabContent(tabName) {
    // Use Turbo to fetch the new content
    fetch(`${window.location.pathname}?tab=${tabName}`, {
      headers: {
        Accept: 'text/vnd.turbo-stream.html, text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Update only the students list content if needed
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newStudentsList = doc.querySelector('.student-cards-container');
        const currentStudentsList = document.querySelector('.student-cards-container');

        if (newStudentsList && currentStudentsList) {
          currentStudentsList.innerHTML = newStudentsList.innerHTML;
        }
      });
  }

  updateTabStyles(activeTab) {
    // Remove active styles from all tabs
    this.tabTargets.forEach((tab) => {
      tab.classList.remove('tw-text-coolGray-950');
      tab.classList.add('tw-text-coolGray-950', 'tw-opacity-60');

      // Hide all indicators
      const indicator = tab.querySelector('[data-learning-trail-tabs-target="indicator"]');
      if (indicator) {
        indicator.classList.add('tw-hidden');
      }
    });

    // Add active styles to clicked tab
    activeTab.classList.remove('tw-opacity-60');
    activeTab.classList.add('tw-text-coolGray-950');

    // Show indicator for active tab
    const activeIndicator = activeTab.querySelector(
      '[data-learning-trail-tabs-target="indicator"]',
    );
    if (activeIndicator) {
      activeIndicator.classList.remove('tw-hidden');
    }
  }

  showTabContent(tabName) {
    // Hide all content sections
    this.contentTargets.forEach((content) => {
      content.classList.add('tw-hidden');
    });

    // Show selected content
    const selectedContent = this.contentTargets.find(
      (content) => content.dataset.tabContent === tabName,
    );

    if (selectedContent) {
      selectedContent.classList.remove('tw-hidden');
    }
  }

  showActiveTab() {
    const activeTabName = this.activeTabValue || 'todos';
    const activeTab = this.tabTargets.find((tab) => tab.dataset.tab === activeTabName);

    if (activeTab) {
      this.updateTabStyles(activeTab);
      this.showTabContent(activeTabName);
    }
  }
}
